import { get, has, kebabCase } from 'lodash';
import { secondsFromTimecode, serialize, assignDefined, timecodeFromSeconds } from '../../utils/ASVPUtils';

import {
    VIDEOS_SITE_URL,
    EMBED_CODE_L,
    EMBED_CODE_R,
    EMBED_URL,
} from '../../constants';


// get the base path from the share config options if set, else use VIDEOS_SITE_URL
export const getBasePath = (options) => (has(options, 'share.basePath')) ? get(options, 'share.basePath') : VIDEOS_SITE_URL;
// get the collection slug from the share config options if set, else use kebabCase(videoSource.collectionTitle)
export const getCollectionSlug = (videoSource, options) => (has(options, 'share.collectionSlug')) ? get(options, 'share.collectionSlug') : kebabCase(videoSource.collectionTitle);
// get the video slug from the share config options if set, else use kebabCase(videoSource.title)
export const getVideoSlug = (videoSource, options) => (has(options, 'share.videoSlug')) ? get(options, 'share.videoSlug') : kebabCase(videoSource.title);

// the adultswim.com url of the video
export const dataURL = (videoSource, options) => `${getBasePath(options)}${getCollectionSlug(videoSource, options)}/${getVideoSlug(videoSource, options)}/`;

// set the custom share parameter (?s=//adultswim.com/special-url) if the share url override is set in the options (this is used by the embed route in /app to reinsert the url for future embeds)
export const shareParam = (options) => get(options, 'share.url', undefined);

// set the time param as seconds (?t=53) if the timecode is defined
export const timeParam = (timecode) => {
    if (!timecode) return undefined;
    return secondsFromTimecode(timecode);
};

// constructs the serialize params for the sharing
export const getURLParams = (params) => serialize(assignDefined({}, { s: params.s, t: params.t }));

// the final link to display on the share overlay (if share link override in options, use that, otherwise use dataURL)
export const getDirectLink = (videoSource, options, timecode) => {
    const params = getURLParams({
        t: timeParam(timecode)
    });
    return (has(options, 'share.url')) ? `${get(options, 'share.url')}?${params}` : `${dataURL(videoSource, options)}?${params}`;
};

// the embed code for the video
export const getEmbedCode = (videoSource, options, timecode) => {
    const params = getURLParams({
        s: shareParam(options),
        t: timeParam(timecode)
    });
    return (videoSource.type === 'clip') ? `${EMBED_CODE_L}${EMBED_URL}${videoSource.id}?${params}${EMBED_CODE_R}` : null;
};

// gets the timecode value from the current seconds of the player (if the type of video can support it)
export const getTimecode = (videoSource, currentTime) => {
    if (videoSource.type === 'stream') return null;

    return timecodeFromSeconds(currentTime);
};



// WEBPACK FOOTER //
// ./src/ui/share/utils.js